import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import apiConfig from '../../config/apiConfig';
import {
  AllCommunityModule,
  ModuleRegistry,
  themeAlpine,
  themeBalham,
} from "ag-grid-community";
import { useRaspStore } from '../../store/raspStore';
import { AgGridReact } from "ag-grid-react";
import { useQuery } from '@tanstack/react-query';
import { LoginContext } from '../../context/LoginContext';
// ADDED: Import your generated model file dynamically
import UsersModel from '../../models/UsersModel';
import { apiFetch } from '../../apis/apiFetch';
ModuleRegistry.registerModules([AllCommunityModule]);
export type ResourceMetaData = {
  "resource": string,
  "fieldValues": any[]
}



const ReadUsers = () => {
  const { user } = useContext(LoginContext);
  const [rowData, setRowData] = useState<any[]>([]);
  const [colDef1, setColDef1] = useState<any[]>([]);
  const [resMetaData, setResMetaData] = useState<ResourceMetaData[]>([]);
  const [fields, setFields] = useState<any[]>([]);
  const [dataToSave, setDataToSave] = useState<any>({});
  const [requiredFields, setRequiredFields] = useState<string[]>([]);
  const [fetchData, setFetchedData] = useState<any[]>([]);
  const [showToast, setShowToast] = useState<any>(false);

  const gridRef = useRef<AgGridReact>(null);

  const exportToCsv = useCallback(() => {
    gridRef.current?.api.exportDataAsCsv({
      fileName: 'registrations_export.csv'
    });
  }, []);

  const regex = /^(g_|archived|extra_data)/;
  const apiUrl = `${apiConfig.getResourceUrl('users')}?`
  const metadataUrl = `${apiConfig.getResourceMetaDataUrl('Users')}?`
  const BaseUrl = '${apiConfig.API_BASE_URL}';
  const getUserAllData = useRaspStore((s) => s.getUserAllData);
  // getUserIdFromJWT removed - using LoginContext
  // Fetch resource data — fetchWithAuth handles token injection, refresh on 401, and redirect on expiry
  const { data: dataRes, isLoading: isLoadingDataRes, error: errorDataRes} = useQuery({
    queryKey: ['resourceData', 'usersRead'],
    enabled: true,
    queryFn: async () => {
      const params = new URLSearchParams();
      params.append("queryId", "GET_ALL");

      const url = `${apiConfig.getResourceUrl('users')}?${params.toString()}`;
      const response = await apiFetch(url, { method: "GET" });

      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }

      const data = await response.json();
      return data.resource;
    },
  })


  // --- Transform API data into model objects and then JSON ---
  useEffect(() => {
    if (dataRes) {
      //console.log("useEffect dataRes", dataRes)
      let dataToStore = { resource: 'users', records: dataRes }
      useRaspStore.getState().initializeStore(user?.userId || "", dataToStore);
      //ADDED: Convert array of plain objects → array of model instances
      const modelObjects = dataRes.map((obj: any) => UsersModel.fromJson(obj));

      // ADDED: Convert array of model instances → array of JSON objects (for ag-grid)
      const jsonObjects = modelObjects.map((model: any) => model.toJson());

      // ADDED: Set final array for AgGrid
      setRowData(jsonObjects);
    }
    //console.log("data initialized in store", getUserAllData(getUserIdFromJWT()),dataRes)
  }, [dataRes, user?.userId]);
 
  const { data: dataResMeta, isLoading: isLoadingDataResMeta, error: errorDataResMeta } = useQuery({
    queryKey: ['resourceMetaData', 'usersRead1'],
    queryFn: async () => {
      const response = await apiFetch(
        `${apiConfig.getResourceMetaDataUrl('users')}?`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }

      const data = await response.json();
      setResMetaData(data);
      setFields(data[0]?.fieldValues || []);
      const required = data[0]?.fieldValues
        .filter((field: any) => !regex.test(field.name))
        .map((field: any) => field.name);
      setRequiredFields(required || []);
      return data;
    },
  });




  useEffect(() => {


    const fields = requiredFields.filter((field: any) => field !== 'id') || [];

    const columns = fields.map((field: any) => {
      // Format the field name for the header: "user_name" -> "User Name"
      let formattedHeader = field
        .split('_')
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

      if (field === 'qualification') {
        formattedHeader = 'Programme';
      }

      return {
        field: field,
        headerName: formattedHeader,
        editable: false,
        resizable: true,
        sortable: true,
        filter: true
      };
    });

    setColDef1(columns);

  }, [requiredFields]);

  const defaultColDef = {
    flex: 1,
    minWidth: 100,
    editable: false,
  };

  return (
    <div>



      <div >
        {rowData.length === 0 && colDef1.length === 0 ? (
          <div>No data available. Please add a resource attribute.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '10px' }}>
              <button
                onClick={exportToCsv}
                className="btn btn-primary"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                  backgroundColor: '#0d6efd',
                  borderColor: '#0d6efd',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '6px',
                  fontWeight: '500'
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                </svg>
                Export
              </button>
            </div>
            <div className="ag-theme-alpine" style={{ height: 500, width: '100%' }}>
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDef1}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationPageSize={10}
                animateRows={true}
                rowSelection="multiple"
              />
            </div>
          </div>
        )}
      </div>
      {showToast && (
        <div
          className="toast-container position-fixed top-20 start-50 translate-middle p-3"
          style={{ zIndex: 1550 }}
        >
          <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header">
              <strong className="me-auto">Success</strong>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="toast"
                aria-label="Close"
                onClick={() => setShowToast(false)}
              ></button>
            </div>
            <div className="toast-body text-success text-center">Created successfully!</div>
          </div>
        </div>
      )}

    </div>
  )


};

export default ReadUsers
